









































































































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import Menus from '@/components/menus'
import ElementTreeLine from 'element-tree-line';
import 'element-tree-line/dist/style.css';
# New features
import OrganizationChart from 'vue-organization-chart'
import 'vue-organization-chart/dist/orgchart.css'

export default {
    name: 'company_hierarchy'

    components: { Menus,ElementTreeLine,OrganizationChart },

    watch:
      filter_text: (val)->
        this.$refs.tree.filter(val)

      filter_text_archived: (val)->
        this.$refs.archived.filter(val)

    data: ()->
        dialog_visible: false
        dialog_vibile2: false
        managers: []
        dirigeants: []
        selected_dirigeant:null
        selected_dirigeant_uid:''
        parent_uid: ''
        user_to_unarchive_uid: ''
        loading: true
        expand_on_click_node: false
        indent: 25
        treeKey: ''
        filter_text: ''
        filter_text_archived: ''
        expand_all: true
        users: null
        ds: {
            id : ""
            name : ""
            title : ""
        }
        archived_users: []
        users_count: 0
        active_name: 'first'
        props: {
          children: 'subordinates',
          label: 'fullnamejobs'
        }
        treeProps: {
                    indent: 35,
                    showLabelLine: true,
                },
    computed:
        draggable: ()->
            return @has_access_right('users_edit')

    methods:
        has_access_right: t.has_access_right

        tab_click: (tab, event)->
            # console.log "TAB IS CHANGE", tab, event
            return

        filter_node: (value, data)->
            if !value
                return true
            return data.fullname.toLowerCase().indexOf(value) != -1

        handle_drop: (draggingNode, dropNode, dropType, ev)->
            # console.log 'handle drop: ', dropNode, dropType, draggingNode
            # console.log 'ARBRE ', JSON.stringify(@users)
            if dropNode.data.is_manager
                @save()
            return

        allow_drop: (draggingNode, dropNode, type)->
            # console.log "DROP ", draggingNode, dropNode, type
            return dropNode.data.is_manager

        allow_drag: (draggingNode)->
            return draggingNode.data.editable

        active_title: (is_active)->
            title = "Activer le compte"
            if is_active
                title = "Bloquer le compte"
            return title

        edit_user: (user)->
            @$store.commit('set_selected_app_user', {'uid':user.uid, 'lastname':user.user_info.lastname, 'firstname':user.user_info.firstname})
            localStorage.setItem("selected_app_user", JSON.stringify(@$store.state.selected_app_user))
            if @$store.state.user_datas.app_user.uid == user.uid
                @$router.push({name:'users_informations', params: {uid: user.uid}})
            else
                @$router.push({name:'company_users_informations', params: {uid: user.uid}})
            return

        change_active: (user)->
            self = @
            h = this.$createElement
            dynamic_text = @active_title(user.is_active)
            text = "Êtes-vous sûr·e de vouloir "+dynamic_text.toLowerCase()+" de ce"
            other_text = "pourra"
            if user.is_active
                other_text = "ne pourra plus"
            @$confirm('', 'Confirmation', {
                message: h('p', null, [
                    h('span', null, text),
                    h('span', { style: 'display:block;'}, "personnel ? La personne "+other_text+" se connecter à son compte."),
                  ]),
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    self.$http.post(settings.change_is_active, {"user_uid": user.uid})
                    .then (resp)->
                        if resp.body.status == "ok"
                            n.success()
                            self.get_tree()
                        else
                            n.error("company_hierarchy: change_active: then", resp.body.message)
                .catch (cancel)->
                    return

        traverse: (object)->
            for o in object
                @users_count++
                if o['subordinates'].length != 0
                    @traverse(o.subordinates)
            return
        icon_role: (role)->
            # roles.forEach (r)->
            # console.log(role)
            if role == 'Dirigeant'
                return 'fa fa-trophy'
            if role == 'Manager'
                return 'fa fa-square'
            if role == 'Collaborateur'
                return 'fa fa-star'
            if role == 'DRH'
                return 'fa fa-users'
            return 'fa fa-star'
        save: ()->
            self = @
            m.run('save_tree', [@users])
            .then (resp)->
                if resp.body.data.tree_mutation.ok
                    # console.log "TREE ", resp.body.data.tree_mutation
                    n.success()
                    self.get_tree()
                else
                    n.error("company_hierarchy: save: then", resp.body.data.tree_mutation.message)
            .catch (resp)->
                n.catch_error(resp, "company_hierarchy: save()")

        get_tree: ()->
            self = @
            @loading = true
            @users_count = 0
            apple = []
            q.run('get_tree', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_hierarchy: get_tree: then" ,e.message)
                else
                    # console.log "GET TREE : ", JSON.stringify(resp.body.data.tree)
                    self.users = resp.body.data.tree
                    self.traverse(resp.body.data.tree)
                    # console.log "TREE COUNT ", self.users_count
                    if self.users_count > 0
                        self.dirigeants = self.users.filter (x)->
                            return x.is_manager == true
                        self.selected_dirigeant = self.dirigeants[0]
                        self.selected_dirigeant_uid = self.dirigeants[0].uid
                        self.org_chart(self.selected_dirigeant)
                        # console.log("SINGLE CHART ", self.selected_dirigeant)
                    if self.users_count >= 50
                        self.expand_all = false
                    self.get_archived_users()
                    self.treeKey = +new Date()
                    self.loading = false
            .catch (resp)->
                n.catch_error(resp, "company_hierarchy: get_tree()")

        get_archived_users: ()->
            self = @
            q.run('get_archived_user_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_hierarchy: get_archived_users: then" ,e.message)
                else
                    # console.log "GET ARCHIVED USERS : ", JSON.stringify(resp.body.data.archived_user_set)
                    self.archived_users = resp.body.data.archived_user_set
            .catch (resp)->
                n.catch_error(resp, "company_hierarchy: get_archived_users()")
        
        set_selected_dirigeant: (item)->
            self = @
            if item != ''
                self.selected_dirigeant_uid = item
                for d in self.dirigeants
                    if d.uid == item
                        self.selected_dirigeant = d
            self.org_chart(self.selected_dirigeant)

        org_role: (item)->
            data = item.roles.map (r)->
                return r.name
            return data.toString()

        org_chart: (item)->
            self = @
            # console.log("ORG CHART ", item)
            self.ds = {
                    'id': item.uid,
                    'name': item.user_info.lastname+" "+item.user_info.firstname,
                    'title': self.org_role(item)
                    children:
                        item.subordinates.map (sub)->
                            {
                                'id': sub.uid,
                                'name': sub.user_info.lastname+" "+sub.user_info.firstname,
                                'title': self.org_role(sub)
                                children:
                                    sub.subordinates.map (sub2)->
                                        {
                                            'id': sub2.uid,
                                            'name': sub2.user_info.lastname+" "+sub2.user_info.firstname,
                                            'title': self.org_role(sub2)
                                                
                                            children:
                                                sub2.subordinates.map (sub3)->
                                                    {
                                                        'id': sub3.uid,
                                                        'name': sub3.user_info.lastname+" "+sub3.user_info.firstname,
                                                        'title': self.org_role(sub3)
                                                            
                                                        children:
                                                            sub3.subordinates.map (sub4)->
                                                                {
                                                                    'id': sub4.uid,
                                                                    'name': sub4.user_info.lastname+" "+sub4.user_info.firstname,
                                                                    'title': self.org_role(sub4)
                                                                        
                                                                    children:
                                                                        sub4.subordinates.map (sub5)->
                                                                            {
                                                                                'id': sub5.uid,
                                                                                'name': sub5.user_info.lastname+" "+sub5.user_info.firstname,
                                                                                'title': self.org_role(sub5)
                                                                                    
                                                                                children:
                                                                                    sub5.subordinates.map (sub6)->
                                                                                        {
                                                                                            'id': sub6.uid,
                                                                                            'name': sub6.user_info.lastname+" "+sub6.user_info.firstname,
                                                                                            'title': self.org_role(sub6)
                                                                                                
                                                                                            children:
                                                                                                sub6.subordinates.map (sub7)->
                                                                                                    {
                                                                                                        'id': sub7.uid,
                                                                                                        'name': sub7.user_info.lastname+" "+sub7.user_info.firstname,
                                                                                                        'title': self.org_role(sub7)
                                                                                                            
                                                                                                        children:
                                                                                                            sub7.subordinates.map (sub8)->
                                                                                                                {
                                                                                                                    'id': sub8.uid,
                                                                                                                    'name': sub8.user_info.lastname+" "+sub8.user_info.firstname,
                                                                                                                    'title': self.org_role(sub8)
                                                                                                                        
                                                                                                                    children:
                                                                                                                        sub8.subordinates.map (sub9)->
                                                                                                                            {
                                                                                                                                'id': sub9.uid,
                                                                                                                                'name': sub9.user_info.lastname+" "+sub9.user_info.firstname,
                                                                                                                                'title': self.org_role(sub9)
                                                                                                                                    
                                                                                                                            }
                                                                                                                    }
                                                                                                        }
                                                                                            }
                                                                            }
                                                                }
                                                    }
                                        }
                            }
            }
            return

        cancel_unarchive_user: ()->
            # console.log "CANCEL UNARCHIVE"
            @dialog_visible = false
            @parent_uid = ''
            @user_to_unarchive_uid = ''
            @managers = []
            return

        unarchive_user: ()->
            # console.log "UNARCHIVE", @parent_uid
            self = @
            @$http.post(settings.change_is_archived, {"user_uid": @user_to_unarchive_uid, "parent_uid": @parent_uid})
            .then (resp)->
                # console.log "USER ARCHIVE", resp
                if resp.body.status == "ok"
                    n.success()
                    self.get_tree()
                    self.cancel_unarchive_user()
                else
                    n.error("company_hierarchy: unarchive_user: then", resp.body.message)
            return

        get_managers: (user_uid)->
            @cancel_unarchive_user()
            self = @
            # console.log "GET MANAGERS ", @$store.getters.current_company.uid
            q.run('get_manager_set', [@$store.getters.current_company.uid, user_uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_hierarchy: get_managers: then", e.message)
                else
                    # console.log "GET MANAGERS : ", resp.body.data.manager_set
                    self.managers.push({uid:'', fullnamejobs:'Aucun'})
                    self.managers = self.managers.concat(resp.body.data.manager_set)
                    self.dialog_visible = true
                    self.user_to_unarchive_uid = user_uid
            .catch (resp)->
                n.catch_error(resp, "company_hierarchy: get_managers()")

        delete_user: (user_uid)->
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer ce personnel et tous les documents et informations le concernant ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "USER DELETE", user_uid
                    m.run('delete_app_user', [user_uid])
                    .then (resp)->
                        # console.log "DELETE USER", resp.body.data.app_user_deletion
                        if resp.body.data.app_user_deletion.ok
                            n.success()
                            self.get_tree()
                        else
                            n.gql_error("company_hierarchy: delete_user: then" ,resp.body.data.app_user_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "company_hierarchy: delete_user()")
                .catch (cancel)->
                    return

        archive_user: (user_uid)->
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir archiver ce personnel ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "USER ARCHIVE", user_uid
                    self.$http.post(settings.change_is_archived, {"user_uid": user_uid})
                    .then (resp)->
                        # console.log "USER ARCHIVE", resp
                        if resp.body.status == "ok"
                            n.success()
                            self.get_tree()
                        else if resp.body.status not in ['functionalError']
                            n.error("company_hierarchy: archive_user: then", resp.body.message)
                .catch (cancel)->
                    return

    beforeMount: ()->
        @get_tree()
}
